import { jsx as _jsx } from "react/jsx-runtime";
// PermissionContext — shared by CP site-admin-ui and DP shell. Holds the
// principal's role/permission snapshot plus per-resource grants used by
// `useHasPermission()`. Plan 23 PR0a promotes DP shell's local permissions
// code to this SDK location so both planes consume the same hook.
import { createContext, useContext, useMemo } from 'react';
/** Empty snapshot — used as the default when no provider is present. */
export const EMPTY_PERMISSION_SNAPSHOT = {
    siteRoles: [],
    sitePermissions: [],
    orgRoles: [],
    orgPermissions: [],
    resourceGrants: [],
};
const PermissionCtx = createContext(EMPTY_PERMISSION_SNAPSHOT);
/** Wrap your app to expose the permission snapshot to the SDK hooks. */
export function PermissionProvider({ children, value, }) {
    // Memoize so consumers using shallow-equal selectors don't re-render
    // unless one of the snapshot arrays actually changed by reference. The
    // snapshot is rebuilt from the fields it depends on, so the dependency list
    // names exactly what the factory reads (#1648).
    const { siteRoles, sitePermissions, orgRoles, orgPermissions, resourceGrants, appPermissionKeys } = value;
    const stable = useMemo(() => ({
        siteRoles,
        sitePermissions,
        orgRoles,
        orgPermissions,
        resourceGrants,
        ...(appPermissionKeys === undefined ? {} : { appPermissionKeys }),
    }), [siteRoles, sitePermissions, orgRoles, orgPermissions, resourceGrants, appPermissionKeys]);
    return _jsx(PermissionCtx, { value: stable, children: children });
}
/** Read the raw permission snapshot — most callers want `useHasPermission` instead. */
export function usePermissionSnapshot() {
    return useContext(PermissionCtx);
}
//# sourceMappingURL=PermissionContext.js.map